<template>
  <div>
    <!-- Videos Grid -->
    <div class="videos-grid">
        
      <div v-for="item in videos" :key="item.id">
        <single-video :video="item" @playVideo="showVideoModal"></single-video>
      </div>      
        
    </div>
    
    <!-- Video Modal -->
    <b-modal v-model="showModal" hide-header :footer-class="'video-modal-footer'" :body-class="'video-modal-body'" centered>
      <div class="iframe-container">
        <iframe :src="currentVideoURL" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen class="responsive-iframe"></iframe>
      </div>

      <template slot="modal-footer">
        <base-button type="secondary" class="ml-auto" @click="showModal = false">Cerrar</base-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import SingleVideo from './SingleVideo'

export default {
  props: ["videos"],
  components: {
    SingleVideo
  },
  data() {
    return {
      showModal: false,
      currentVideoURL: ''
    }
  },
  methods: {
    showVideoModal(videoID) {
      this.currentVideoURL = `https://player.vimeo.com/video/${videoID}`
      this.showModal = true
    }
  }
}
</script>

<style>
.videos-grid {
  display: grid;
  justify-content: space-evenly;
  padding: 30px;
  gap: 2rem;
  /* grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); */
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
}

/* iframe classes */
.iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.video-modal-footer {
  padding: 1rem 1rem 1rem 0;
}

.video-modal-body {
  padding: 0;
  background-color: black;
}

</style>